export default theme => ({
  coreContainer: {
    paddingTop: 64
  }
});
